export interface IVideoBlockProps {
  busteriframetitle?:string;
  screen9iframetitle?:string;
  heading?: string;
  description?: string;
  videoUrl: string;
  defaultTextLang?: string;
  blockId?: string;
  campaign?: boolean;
  anchorHeading?: boolean;
}

export interface IVideoBlockState {
  isPlaying: boolean;
  isInitialPlay: boolean;
  videoTitle: string;
  videoProvider: VideoProvider;
  playEvents: boolean[];
  canPlayVideo: boolean;
  previousSeekPercent: number;
}

export interface ProgressState {
  played: number;
  playedSeconds: number;
  loaded: number;
  loadedSeconds: number;
}

export enum VideoProvider {
  Undefined,
  Youtube,
  Vimeo,
  Buster,
  screen9,
}
